export default __webpack_public_path__ + "static/FuturaBT-Book-6c41abad920f0315c4affaaced7d644d.woff";